import { Link } from "react-router-dom";

export default function AboutSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-2/5">
            <p className="text-xs md:text-sm font-medium text-foreground-500 tracking-[0.15em] uppercase mb-3 whitespace-nowrap">
              About the System
            </p>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-[1.15]">
              What is
              <br />
              ItaobuySpreadsheet?
            </h2>
          </div>
          <div className="lg:w-3/5">
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-4">
              <strong className="text-foreground-950">itaobuyspreadsheet</strong> is a structured product sourcing system that helps users find verified products, compare suppliers, and streamline cross-border shopping through organized spreadsheets. Unlike traditional manual searching, the <strong className="text-foreground-950">itaobuy spreadsheet</strong> system gives buyers an immediate overview of available products across multiple categories.
            </p>
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-6">
              Instead of spending hours manually searching through supplier pages, users who rely on the <strong className="text-foreground-950">itaobuyspreadsheet</strong> method access pre-organized product lists, pricing transparency data, and supplier comparisons in one unified interface. This makes the entire sourcing workflow dramatically faster and more reliable for dropshippers, Amazon sellers, and eCommerce entrepreneurs worldwide.
            </p>
            <Link
              to="/what-is-itaobuy-sheet"
              className="inline-flex items-center gap-2 text-sm font-semibold text-accent-600 hover:text-accent-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Read our beginner guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10 mt-16 md:mt-20">
          {[
            { value: "60%", label: "Faster Sourcing" },
            { value: "1000+", label: "Live Items Updated Weekly" },
            { value: "14", label: "Categories Full Coverage" },
            { value: "24/7", label: "Auto Refresh System" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="font-heading text-4xl md:text-6xl font-bold text-foreground-950 mb-2 tracking-tight">
                {stat.value}
              </div>
              <p className="text-xs md:text-sm text-foreground-500 whitespace-nowrap">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}